import React, { useState } from 'react';
import { Form, Input, Row } from 'antd';
import { MaskedInput } from 'antd-mask-input';
import { api, useCrudEditContext, FormItemWrap } from '@unicus/react-ui-kit';
import { postalCodeValidator } from 'util/validators';
import lodash from 'lodash';
import ResCol from './ResCol';
import RemoteSelectV2 from './RemoteSelectV2';

const AddressV2 = ({
  name = ['address'],
  required = true,
  disabled = false
}) => {
  const [state, setState] = useState({
    lastPostalCode: null,
    loadingAddress: false
  });

  const { form } = useCrudEditContext();

  const setAddress = (newAddress) => {
    form.setFieldsValue(lodash.set({}, name, newAddress));
  };

  const findAddress = (postalCode) => {
    postalCode = postalCode.replace(/[^0-9.]/g, '');

    if (state.lastPostalCode === postalCode) {
      return;
    }

    setState({ ...state, lastPostalCode: postalCode, loadingAddress: true });

    api.fetch('localizations', { postalCode }).then(({ data }) => {
      setState({ ...state, loadingAddress: false });
      setAddress(
        data
          ? data.result
          : {
              street: null,
              number: null,
              district: null,
              additionalInformation: null,
              city: undefined
            }
      );
    });
  };

  const postalCodeChangeHandle = (sender) => {
    const postalCode = sender.target.value.replace(/[^0-9.]/g, '');
    if (postalCode.length === 8) {
      findAddress(postalCode);
    }
  };

  return (
    <>
      <Row>
        <ResCol span={6}>
          <FormItemWrap
            name={[...name, 'postalCode']}
            label="CEP"
            required={required}
            validateTrigger="onBlur"
            rules={[{ validator: postalCodeValidator }]}
            hasFeedback={state.loadingAddress}
            validateStatus={state.loadingAddress ? 'validating' : undefined}
          >
            <MaskedInput
              mask="11111-111"
              onChange={postalCodeChangeHandle}
              disabled={disabled}
            />
          </FormItemWrap>
        </ResCol>
        <ResCol span={18}>
          <FormItemWrap
            name={[...name, 'street']}
            label="Logradouro"
            required={required}
            whitespace
          >
            <Input maxLength={100} disabled={disabled} />
          </FormItemWrap>
        </ResCol>
      </Row>
      <Row>
        <ResCol span={6}>
          <FormItemWrap
            name={[...name, 'number']}
            label="Número"
            required={required}
            whitespace
          >
            <Input maxLength={40} disabled={disabled} />
          </FormItemWrap>
        </ResCol>
        <ResCol span={18}>
          <FormItemWrap
            name={[...name, 'additionalInformation']}
            label="Complemento"
          >
            <Input maxLength={100} disabled={disabled} />
          </FormItemWrap>
        </ResCol>
      </Row>
      <Row>
        <ResCol span={14}>
          <FormItemWrap
            name={[...name, 'district']}
            label="Bairro"
            required={required}
            whitespace
          >
            <Input maxLength={40} disabled={disabled} />
          </FormItemWrap>
        </ResCol>
        <ResCol span={10}>
          <FormItemWrap
            name={[...name, 'city']}
            label="Cidade/Estado"
            required={required}
          >
            <RemoteSelectV2
              resource="cities"
              disabled={disabled}
              normalizeLabel={(c) => `${c.name} - ${c.state.toUpperCase()}`}
            />
          </FormItemWrap>
        </ResCol>
      </Row>
    </>
  );
};

export default AddressV2;
